"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getPlatform() {
    const { platform = '', userAgent = '', maxTouchPoints = 0 } = navigator || {};
    if (['iPad', 'iPhone', 'iPod'].includes(platform) ||
        (userAgent.includes('Mac') && maxTouchPoints > 0)) {
        return 'iOS';
    }
    if (/Android/i.test(userAgent)) {
        return 'Android';
    }
    return 'Others';
}
exports.default = getPlatform;
